import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useBreakpoints } from 'frontend/js/modules/infra/dls/hooks/use-get-breakpoints';
import { useSession } from 'frontend/js/modules/infra/session/use-session';
import { useApiMutation } from 'frontend/js/modules/infra/api/hooks/use-api-mutation';
import { LanguageSettings } from './language-settings';
import { endpoints } from '../network/endpoints';
export var LanguageSettingsContainer = function () {
    var session = useSession().data;
    var _a = useState((session === null || session === void 0 ? void 0 : session.user.preferredLanguage) || 'en'), selectedLanguage = _a[0], setSelectedLanguage = _a[1];
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var updateUserSettingsMutation = useApiMutation({
        endpoint: endpoints.updateUserSettingsMutation,
    });
    var onSubmit = function (language) {
        updateUserSettingsMutation.mutate({
            preferredLanguage: language,
        });
    };
    var handleSelectedLanguageChange = function (language) {
        setSelectedLanguage(language);
        if (isMobileOrSmaller) {
            onSubmit(language);
        }
    };
    return (_jsx(LanguageSettings, { onSubmit: onSubmit, selectedLanguage: selectedLanguage, onSelectedLanguageChange: handleSelectedLanguageChange, showSaveButton: !isMobileOrSmaller, isMobileOrSmaller: isMobileOrSmaller }));
};
